export default function convertToFractional(amount) {
  return typeof(amount) !== 'object' ? {fractional: amount} : amount
}